import * as yup from "yup";
import { Question } from "../EntityTypeSurvey/types";

export const entitySurveySchema = yup.object({
  updatedQuestions: yup
    .array()
    .of(
      yup.object({
        id: yup.string().required(),
        question: yup.string().required(),
        answer: yup.string(),
      }),
    )
    .test(
      "questions-validation",
      "All required fields and questions must be completed in order to complete this section",
      (questions?: Question[]) => {
        if (!questions) return false;

        const questionAnsweredAffirmatively = questions.some(
          (question) => question.answer === "Yes",
        );
        const allQuestionsAnsweredNegatively = questions.every(
          (question) => question.answer === "No",
        );

        return questionAnsweredAffirmatively || allQuestionsAnsweredNegatively;
      },
    )
    .required(),
});
